export default "__VITE_ASSET__34b23890__"